import * as cornerstoneMath from 'cornerstone-math';

let cornerstone = window.cornerstone;
let $ = window.$;
let Hammer = window.Hammer;

const external = {
  set cornerstone (cs) {
    cornerstone = cs;
  },
  get cornerstone () {
    return cornerstone;
  },
  set $ (module) {
    $ = module;
  },
  get $ () {
    return $;
  },
  set Hammer (module) {
    Hammer = module;
  },
  get Hammer () {
    return Hammer;
  }
};

export { cornerstoneMath, external };



// WEBPACK FOOTER //
// ./externalModules.js